import { useEffect, useMemo } from 'react'
import { debounce } from 'lodash'
import { Alert, Text } from '@/ui'
import { TypographyStyles } from '@/styles'
import { useAppDispatch } from '@/utils/typeHelpers'
import { fetchCubkProgress } from './lib/cubkProgress.slice'

const RETRY_DEBOUNCE_MS = 1000

export const CubkCardError = () => {
  const dispatch = useAppDispatch()

  // Leading-edge debounce so rapid clicks don't queue duplicate fetches.
  const handleRetry = useMemo(
    () =>
      debounce(
        () => {
          dispatch(fetchCubkProgress({ forceFetch: true }))
        },
        RETRY_DEBOUNCE_MS,
        { leading: true, trailing: false }
      ),
    [dispatch]
  )

  useEffect(() => {
    return () => {
      handleRetry.cancel()
    }
  }, [handleRetry])

  return (
    <div data-testid="cubk-card-error">
      <Text variant={TypographyStyles.H1}>Catch Up Bookkeeping</Text>
      <div className="mt-8">
        <Alert
          variant="warning"
          title="We couldn't load your bookkeeping progress"
          description="If this persists, please reach out to support."
          ctaText="Retry"
          ctaOnClick={handleRetry}
          ctaProps={{ variant: 'secondary' }}
        />
      </div>
    </div>
  )
}
